/**
 * NSW Design System masthead — the "A NSW Government website" strip that sits
 * above the site header on every NSW Government site.
 * https://designsystem.nsw.gov.au/components/masthead/index.html
 *
 * The skip links are part of the same component in the design system. They
 * target real landmarks on this page rather than "#", which would be worse
 * than having no skip link at all.
 */
const NswMasthead = () => (
  <>
    <nav className="nsw-skip" aria-label="Skip to links">
      <a href="#nsw-hero-banner">
        <span>Skip to content</span>
      </a>
      <a href="#wtd2023InteractiveMap">
        <span>Skip to the map</span>
      </a>
    </nav>
    <div className="nsw-masthead">
      <div className="nsw-container">A NSW Government website</div>
    </div>
  </>
);

export default NswMasthead;
